import useSWR from 'swr';

import ProductService from '@/services/modules/ProductService';

import { type ParsedFilterData, parseCatalogFilters } from '../themes/cray26/lib/filters';

const EMPTY_FILTER_DATA: ParsedFilterData = parseCatalogFilters(null);

const fetchCatalogFilters = async (): Promise<ParsedFilterData> => {
  try {
    const psvc = new ProductService();
    const res = await psvc.getFilterOptions();
    return parseCatalogFilters(res);
  } catch (_) {
    // API unavailable or returned 4xx/5xx — return empty filters so the UI
    // still renders without crashing.
    return EMPTY_FILTER_DATA;
  }
};

export const useFilterOptions = () => {
  return useSWR<ParsedFilterData>('catalogFilters', fetchCatalogFilters);
};
